import { restDelete, restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { TableDto } from "./restModels";
import {
    CreateTableRequestDto,
    CreateTablesBatchRequestDto,
    UpdateTableRequestDto,
} from "./restRequests";

// ===== Столы заведения (REST /api/rest/warehouse/v1) =====
// Заведение бэк берёт из аккаунта — organizationBranchId в запросах не передаём.

export const getTables = () => restGet<TableDto[]>("/tables");

export const createTable = (body: CreateTableRequestDto) =>
    restPost<TableDto>("/tables", body);

// Создание пачкой и удаление возвращают весь список — клиенту не нужен второй запрос.
export const createTablesBatch = (body: CreateTablesBatchRequestDto) =>
    restPost<TableDto[]>("/tables/batch", body);

export const updateTable = (tableId: number, body: UpdateTableRequestDto) =>
    restPut<TableDto>(`/tables/${tableId}`, body);

export const deleteTable = (tableId: number) =>
    restDelete<TableDto[]>(`/tables/${tableId}`);
